module.exports = __webpack_public_path__ + "static/media/ic-wallet-number.2efc97ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/portfolio/truebalance/images/ic-wallet-number.svg
// module id = 1358
// module chunks = 0